goog.provide('el8.appchart.visitNote.textlist');

goog.require('el8.template.appchart.visitNote');
goog.require('el8.uiwidget.deleteConfirm');

/**
 * A textlist refers to a list that is just a list of text and is
 * not editable. These are used for visit note sections where the user
 * cannot type into the fields to populate them; instead they are
 * populated by referencing a document into note, or writing an order
 * that then becomes owned by the visit note.
 */

el8.appchart.visitNote.textlist = function(spec) {

    spec = spec || {};
    this._isInit = false;
    this._sectionElt = spec.sectionElt || null;

    /* Can be deprecated after we start supporting amendments of
     * owned docs and ref'd docs [i.e. non-bullet/editable] */
    this._isEdit = Boolean(spec.isEdit);

    this._list = spec.list;
    this._removeFn = spec.removeFn || function() {};

    this._set = spec.set;
    this._note = spec.note;
};

el8.appchart.visitNote.textlist.prototype.init = function() {
    var that = this;
    if (this._sectionElt) { this._sectionElt.hide(); }
    this._list.on('click', '.textlist-item-remove-trigger',  function(e) {
        var itemId = $(this).attr('data-id')*1;
        var bullet = that._set.getById(itemId);
        if (bullet.isDocumentOwnedBy()) {
            var doc = el8.ptdata.fetch({fetchIds: bullet.getDocumentId()});
            if ( (doc.is('MedOrder') && doc.isDocumentMed()) || doc.is('ReferralOrder') ) {
                el8.appchart.dialog.removeOrder.show(that._note, doc, function(order) {
                    that.removeOwnedDoc(order.getId());
                });
            } else {
                el8.uiwidget.deleteConfirm("order",
                    function() {
                        var entitySet = el8.ptdata.getEntitySet(doc.getModelClass());
                        // Listeners will then trigger removeNewOrder on visit note as needed
                        entitySet.deleteItem(doc);
                    }
                );
            }
        } else {
            that._removeEntry(bullet);
        }

    }).on('click', '.details-trigger',  function(e) {
        var docId = $(this).attr('data-id')*1;
        el8.appchart.showItemDetail(docId);
        return false;
    });
    return this;
};
el8.appchart.visitNote.textlist.prototype.addEntry = function(item, doHighlight) {
    var that = this;

    if (this._sectionElt && this._sectionElt.is(':hidden')) { this._sectionElt.show(); }

    var $textlistItem; // keep a reference around so we can fill in the data-id fields later
    var _populateEntry = function(_item) {
        $textlistItem = $(el8.template.appchart.visitNote.textlistItem({
            id: _item.getId(),
            docId: _item.getDocumentId(),
            summary: _item.getDocumentSummary(),
            summaryFormatting: _item.getDocumentSummaryFormatting(),
            isEdit: that._isEdit
        }));
        that._list.append($textlistItem);
    };

    /* Populate entry
     *
     * Note that on-the-fly entries won't have IDs yet, so their data-id fields will
     * have to be populated in the AJAX callback below. If we instead called
     * populateEntry in the callback, we could not guarantee that addEntry called
     * for entries 1,2,3,4 would end up adding those entries in that order. */
    _populateEntry(item);

    /* If this is a fresh on-the-fly add of an entry, it won't have ID, so do save */
    if (!item.getId()) {
        var index = this.numEntries() - 1;
        item.setSequence(index);
        this._set.saveItem(item, false, {
            successCb: function() {
                $textlistItem.attr('data-id', item.getId());
                $textlistItem.find('.textlist-item-remove-trigger').attr('data-id', item.getId());
                /* If referenced document is owned, do update of chart feed so
                 * the document doesn't show up there */
                if (item.isDocumentOwnedBy()) {
                    el8.appchart.mainFeeds.chart.update();
                }
            }
        });
    }
};
el8.appchart.visitNote.textlist.prototype.removeOwnedDoc = function(docId) {
    var bullet = this._set.getByReferencedDocId(docId);
    if (bullet && bullet.isDocumentOwnedBy()) {
        this._removeEntry(bullet);
    }
};
el8.appchart.visitNote.textlist.prototype._removeEntry = function(item) {
    if (!item) { return null; }
    var itemId = item.getId();
    $('.textlist-item[data-id="'+itemId+'"]', this._list).remove();
    this._removeFn(itemId);
    if (this._sectionElt && !$('.textlist-item', this._list).length) {
        this._sectionElt.hide();
    }
};
el8.appchart.visitNote.textlist.prototype.numEntries = function() {
    return $('.textlist-item', this._list).length;
};
